import { render } from "./LiveRegion.3.vue?vue&type=template&id=46576a8f&ts=true"
import script from "./LiveRegion.3.vue?vue&type=script&lang=ts"
export * from "./LiveRegion.3.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__